export const modifyFormData = (payload: any, formData: any) => {

    payload?.query_text && formData.append('query_text', payload?.query_text);
    
    payload?.input_prompt && formData.append('input_prompt', payload?.input_prompt);

    payload?.engine && formData.append('engine', payload?.engine);

    payload?.question_prompt_template && formData.append('question_prompt_template', payload?.question_prompt_template);

    payload?.refine_prompt_template && formData.append('refine_prompt_template', payload?.refine_prompt_template);

    payload?.user_input && formData.append('user_input', payload?.user_input);

    payload?.custome_prompt && formData.append('custome_prompt', payload?.custome_prompt);
  
    payload?.summarization_prompt && formData.append('summarization_prompt', payload?.summarization_prompt);

    payload?.summarization_type && formData.append('summarization_type', payload?.summarization_type);

    payload?.unique_kdb && formData.append('unique_kdb', payload?.unique_kdb);

    payload?.user_id && formData.append('user_id', payload?.user_id);

    payload?.project_status && formData.append('project_status', payload?.project_status);

    payload?.username && formData.append('username', payload?.username);

    payload?.project_name && formData.append('project_name', payload?.project_name);

    payload?.project_type && formData.append('project_type', payload?.project_type);

    payload?.version && formData.append('version', payload?.version);

    payload?.query && formData.append('query', payload?.query);
    
    payload?.file_name && formData.append('file_name', payload?.file_name);
    
    payload?.reload && formData.append('reload', payload?.reload)

    payload?.template && formData.append('template', payload?.template)

    payload?.kdbName && formData.append('kdb_name', payload?.kdbName)

    payload?.project_id && formData.append('project_id', payload?.project_id)

    payload?.prompt && formData.append('prompt', payload?.prompt)

    payload?.prompt_query && formData.append('prompt_query', payload?.prompt_query)

    payload?.project_description && formData.append('description', payload?.project_description)

    if (payload?.files && payload?.files?.length > 0) {
      payload?.files?.forEach((file: any) => {
        if(file.value){
          formData.append('files', new File([file?.value], file?.path)); 
        }else{
          formData.append('files', file); 
        }
      }
      )
    }
    return formData;
}

export const configFormData = {
  headers: {
    'content-type': 'multipart/form-data',
  },
};

export const configFormProductionData = {
  headers: {
    'content-type': 'multipart/form-data',
    'user-id': ''
  },
};

export const configFormDataTimeOut = {
  headers: {
    'content-type': 'multipart/form-data',
    'timeout': 2 * 60 * 1000,
  },
};